/** Telegram WebApp haptics — silently no-op outside Telegram. */
function hf() {
  return typeof window !== 'undefined' ? window.Telegram?.WebApp?.HapticFeedback : null;
}

export function impact(style = 'light') {
  try { hf()?.impactOccurred?.(style); } catch (e) { /* ignore */ }
}

export function notify(type = 'success') {
  try { hf()?.notificationOccurred?.(type); } catch (e) { /* ignore */ }
}

export function selection() {
  try { hf()?.selectionChanged?.(); } catch (e) { /* ignore */ }
}
